export default function PolitiqueConfidentialite() {
  return (
    <div className="animate-fade-in">
      <section className="bg-oya-black pt-28 pb-12 md:pt-36 md:pb-16 px-4">
        <div className="max-w-4xl mx-auto">
          <h1 className="font-serif text-3xl md:text-4xl font-bold text-white">Politique de confidentialité</h1>
        </div>
      </section>

      <section className="py-12 md:py-20 px-4 bg-white">
        <div className="max-w-4xl mx-auto space-y-10">
          <div>
            <h2 className="text-xl font-bold text-oya-black mb-3">1. Introduction</h2>
            <p className="text-oya-gray-medium leading-relaxed">
              Le site OYA PHONE est un site vitrine de présentation des services de réparation de téléphones, tablettes et consoles.
              À ce jour, il ne collecte aucune donnée personnelle directement.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-bold text-oya-black mb-3">2. Données personnelles collectées</h2>
            <p className="text-oya-gray-medium leading-relaxed">
              Aucune donnée personnelle n'est collectée directement par le site. Il n'y a ni formulaire de contact, ni création de
              compte client, ni newsletter, ni espace membre, ni paiement en ligne.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-bold text-oya-black mb-3">3. Cookies et traceurs</h2>
            <p className="text-oya-gray-medium leading-relaxed">
              Ce site n'installe aucun cookie ou traceur nécessitant votre consentement, et aucun outil publicitaire ou de mesure
              d'audience n'est utilisé. Aucune bannière de consentement aux cookies n'est donc nécessaire.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-bold text-oya-black mb-3">4. Données de connexion</h2>
            <p className="text-oya-gray-medium leading-relaxed">
              L'hébergeur (Cloudflare, Inc.) peut enregistrer de manière automatisée des données techniques de connexion (telles que
              l'adresse IP) à des fins de sécurité et de bon fonctionnement du service. Ces journaux ne sont pas utilisés par OYA PHONE
              pour identifier les visiteurs.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-bold text-oya-black mb-3">5. Liens externes</h2>
            <p className="text-oya-gray-medium leading-relaxed">
              Le site peut contenir des liens (notamment affiliés) vers des sites tiers. Lorsque vous cliquez sur ces liens, vous quittez
              le site OYA PHONE et êtes soumis aux politiques de confidentialité de ces sites tiers, sur lesquelles OYA PHONE n'a aucun contrôle.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-bold text-oya-black mb-3">6. Vos droits</h2>
            <p className="text-oya-gray-medium leading-relaxed">
              Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez de droits sur vos données personnelles.
              Dans la mesure où le site n'en collecte aucune directement, vous pouvez adresser toute demande à l'éditeur :
            </p>
            <ul className="mt-2 space-y-1 text-oya-gray-medium">
              <li>Email : <a href="mailto:oyaphone29@gmail.com" className="text-oya-red hover:underline">oyaphone29@gmail.com</a></li>
              <li>Téléphone : <a href="tel:0651004790" className="text-oya-red hover:underline">06 51 00 47 90</a></li>
              <li>Adresse : 7, Quélerec, 29840 Landunvez</li>
            </ul>
          </div>

          <div>
            <h2 className="text-xl font-bold text-oya-black mb-3">7. Mise à jour</h2>
            <p className="text-oya-gray-medium leading-relaxed">
              Cette politique de confidentialité pourra être mise à jour en cas d'évolution du site (ajout d'un formulaire, d'une
              newsletter, etc.). La date de dernière mise à jour figure ci-dessous.
            </p>
            <p className="text-sm text-oya-gray-medium mt-2">
              Dernière mise à jour : août 2026
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}